import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const listData = async (params) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/country`);
        console.log("country-response", response)
        return await response.data;
    } catch (error) {
        console.log("listData - error", error)
        return handleApiError(error)
    }
}

export const allCountryList = async (params) => {
    try {
        let data = {
            lazyload: params?.lazyEvent
        }
        const response = await axios.post(`${REACT_APP_API_URL}/country`,data);
        return await response.data;
    } catch (error) {
        console.log("allCountryList - error", error)
        return handleApiError(error)
    }
}

export const getCountryDataById = async (countryId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/country/${countryId}`);
        return await response.data;
    } catch (error) {
        console.log("getCountryById - error", error)
        return handleApiError(error)
    }
}

export const addCountryData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/country/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addCountry - error", error)
        return handleApiError(error)
    }
}